export default {
  remote: 'simplify_hub_agent_mfe',
  name: 'agent',
  source: 'https://github.com/telus/simplify-agent-mfe',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-agent/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-agent/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-agent/v1/mf2/mf-manifest.json',
  },
};
